import { createSelector } from 'reselect';
import { State } from './slice';
import { Coin } from './types';

const getState = (state: any): State => state.tokenTeam;

export const getAvatar = createSelector(
  [getState],
  state => state.avatar,
);

export const getTwitterHandle = createSelector(
  [getState],
  state => state.twitterHandle,
);

export const getCoins = createSelector(
  [getState],
  state => state.coins,
);

export const getSelectedCoin = createSelector(
  [getState],
  state => state.selectedCoin,
);

export const getCoinCodes = createSelector(
  [getCoins],
  coins => coins.map((coin: Coin) => coin.code).sort(),
);

export const getFetchStatus = createSelector(
  [getState],
  state => state.fetched,
);

export const getInfoFetchStatus = createSelector(
  [getFetchStatus],
  fetched => fetched.info,
);

export const getCoinFetchStatus = createSelector(
  [getFetchStatus],
  fetched => fetched.coin,
);

export const getSelectedCoinInfo = createSelector(
  [getState, getSelectedCoin],
  (state, selectedCoin) =>
    state.coins.find((coin: Coin) => coin.code === selectedCoin.code)!,
);
